module.exports = __webpack_public_path__ + "img/4_SZTFH_Panaszkezeles.f21457d1.jpg";